.panel {
  padding: 14px 16px;
  border: 1px solid var(--line);
  border-radius: var(--radius-card);
  background: var(--panel);
  box-shadow: var(--shadow-panel);
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.title {
  margin: 0;
  font-size: var(--t-head);
  font-weight: 650;
}

.list {
  display: grid;
  margin: 0;
}

.row {
  min-width: 0;
  padding: 8px 0;
  border-top: 1px solid var(--line);
}

.row:first-child {
  border-top: 0;
}

.label {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

.value {
  min-width: 0;
  margin: 0;
  color: var(--ink);
  font-size: var(--t-body);
  font-variant-numeric: lining-nums tabular-nums;
  overflow-wrap: anywhere;
}

.stacked .value {
  margin-top: 2px;
}

.inline .row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
}

.inline .value {
  text-align: right;
}

.mono {
  font-family: var(--mono);
  font-size: var(--t-dense);
}
